export default __webpack_public_path__ + "e4475e05244cb78802065326e62b1815.png";